import Cookies from 'universal-cookie';
import { userDataActions } from '../../reducers/userData/userData';
import { getRequest } from '../../../shared/axiosRequest';
import { API_PATHS, EPC_COOKIES_KEY } from '../../../shared/apiConsts';
import { wt_decode } from '../../../shared/utility';

export const renewTokenAndSetCookie = async () => {
  const cookies = new Cookies();
  const tokenBody = await getRequest(
    API_PATHS.EXTERNAL_API.LOGIN_TOKEN,
    {},
    { withCredentials: true }
  );
  try {
    cookies.set(EPC_COOKIES_KEY, tokenBody.token, { path: '*' });
  } catch (error) {
    console.log('renewTokenAndSetCookie - ERROR', error);
  }
  return tokenBody.token;
};

export const getUserData = () => {
  return async dispatch => {
    try {
      const tokenBody = await renewTokenAndSetCookie();
      const user = wt_decode(tokenBody);
      dispatch(userDataActions.setUserData(user));
    } catch (error) {
      console.error(error);
    }
  };
};
